import React from 'react'

function Coaching() {
  return (
    <div>Coaching</div>
  )
}

export default Coaching